import { __assign } from "tslib";
import * as React from 'react';
function IconCheckSizeM(props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.181 16.255L3.287 10.47 2 12.004l8.427 7.07 11.57-13.789L20.465 4 10.18 16.255z" })));
}
export default IconCheckSizeM;
